// Pain artwork registry. Pain coordinate frames are versioned independently of
// Trainer art because a saved pinpoint/radiation path is meaningful only on the
// exact SVG that received it (BODY_MAP_REDRAW_PLAN.md, Session 2A).
//
// `legacyV1/` is a mechanical archive of the pre-redraw body-map modules. Do
// not edit it when authoring v2: add a new registry entry instead. This lets old
// records remain drawable even after the live artwork changes.

import {
  LEGACY_PAIN_ARTWORK_VERSION,
  resolvePainArtworkVersion,
  type PainArtworkVersion,
  type PainView,
} from "@medassist/shared";
import {
  PAIN_VIEW_DATA as LEGACY_V1_PAIN_VIEW_DATA,
  type PainRegion,
  type PainViewData,
} from "./legacyV1/painRegions.js";

export type { PainRegion, PainViewData };

export const PAIN_ARTWORK_REGISTRIES: Partial<Record<PainArtworkVersion, Record<PainView, PainViewData>>> = {
  [LEGACY_PAIN_ARTWORK_VERSION]: LEGACY_V1_PAIN_VIEW_DATA,
};

/** Returns undefined for an unknown or not-yet-installed registry. Readers must
 * render their explicit unsupported-artwork state rather than falling forward. */
export function painArtworkFor(version: unknown): Record<PainView, PainViewData> | undefined {
  const resolved = resolvePainArtworkVersion(version);
  return resolved === null ? undefined : PAIN_ARTWORK_REGISTRIES[resolved];
}

export function painViewDataFor(version: unknown, view: PainView): PainViewData | undefined {
  return painArtworkFor(version)?.[view];
}

